import { RetornaAceiteTermoResponse } from "../../../interfaces/entities/RetornaAceiteTermoResponse";
import { TermoResponsabilidade } from "../../../interfaces/entities/TermoResponsabilidade";
import { Diario } from "../../../interfaces/entities/UnimedAcolhe/Diario";

export const defaultDiary: Diario = {
    details: []
}

export const defaltAcceptTerm: RetornaAceiteTermoResponse = {
    idTermoAceite: 0,
    idTermoResponsabilidade: 0,
    indAceite: '',
    idOperador: 0,
}

export const defaltTerm: TermoResponsabilidade = {
    idTermoResponsabilidade: '',
    codigo:                  '',
    descricao:               '',
    abrevSist:               ''
}